import * as stylex from '@stylexjs/stylex';

const fadeIn = stylex.keyframes({
  from: {
    opacity: 0,
    transform: 'scale(0.75)',
  },
  to: {
    opacity: 1,
    transform: 'scale(1)',
  },
});

const fadeOut = stylex.keyframes({
  from: {
    opacity: 1,
    transform: 'scale(1)',
  },
  to: {
    opacity: 0,
    transform: 'scale(0.75)',
  },
});

export const styles = stylex.create({
  popover: {
    zIndex: 1,
    position: 'fixed',
    maxWidth: '100vw',
    maxHeight: '100dvh',
    margin: 0,
    padding: 0,
    border: 'none',
    background: 'transparent',
  },
  opening: {
    animationName: fadeIn,
    animationDuration: '0.1s',
    animationTimingFunction: 'ease-in',
  },
  closing: {
    animationName: fadeOut,
    animationDuration: '0.1s',
    animationTimingFunction: 'ease-in',
    animationFillMode: 'forwards',
  },
});
